import { render, staticRenderFns } from "./ErstelleBuKundenHerstellerUmsaetze.vue?vue&type=template&id=2672c9bf&"
import script from "./ErstelleBuKundenHerstellerUmsaetze.vue?vue&type=script&lang=js&"
export * from "./ErstelleBuKundenHerstellerUmsaetze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports